import { Component, EventEmitter, Input, Output } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { UserService } from "src/app/_services";
import { DataRowComponent } from "../../_component/pagination-client-side/data-row.component";

@Component({
  selector: "app-company-view",
  templateUrl: "./company-view.component.html",
  styleUrls: [
    "./company-view.component.scss",
    "./../../../_styles/ion-grid-content-table.scss",
  ],
})
export class CompanyViewComponent implements DataRowComponent {
  @Input()
  row: any;

  @Input()
  displayMobileView = false;

  @Input()
  styleClass;

  @Output()
  refreshRequest: EventEmitter<any> = new EventEmitter<any>();

  @Output()
  actionRequest: EventEmitter<any> = new EventEmitter<any>();

  constructor(
    private userServ: UserService,
    private router: Router,
    private route: ActivatedRoute
  ) {}

  checkPermission(companyId: number): Boolean {
    if (
      this.userServ.permissionEditCompany(
        companyId,
        ["company.edit"],
        ["company.edit.only-my-company"]
      )
    ) {
      return true;
    } else {
      return false;
    }
  }

  editCompany(companyId: number) {
    if (this.checkPermission(companyId)) {
      this.router.navigateByUrl("app/company/edit/" + this.row.id);
    }
  }
}
